/**
 * Validates if an MMSI number is valid.
 * MMSI must be a positive number and cannot be 0 or -1 (sentinel value).
 */
export const isValidMMSI = (
  mmsi: number | null | undefined,
): mmsi is number => {
  return mmsi != null && mmsi !== 0 && mmsi !== -1 && mmsi > 0;
};

export class InvalidMMSIError extends Error {
  constructor(mmsi: number | null | undefined) {
    super(
      `Invalid MMSI: ${mmsi}. MMSI must be a positive number and cannot be 0 or -1.`,
    );
    this.name = 'InvalidMMSIError';
  }
}
